import { Modal } from '@mantine/core';
import { ReactElement } from 'react';
import FormHeader from 'app/views/components/Form/form-header';
import StepperTabs, { StepperTab } from './StepperTabs';


interface StepperModalProps<T> {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    subtitle: string;
    steps: StepperTab<T>[];
    currentTab: T;
    setTab: React.Dispatch<React.SetStateAction<T>>;
    goTo: (tab: T) => void;
    children: ReactElement;
    size?: string;
}

export default function StepperModal<T>({
    open,
    setOpen,
    title,
    subtitle,
    steps,
    currentTab,
    setTab,
    goTo,
    children,
    size = "77%",
}: StepperModalProps<T>) {
    return (
        <Modal
            className="modal-body create-new-form fit-content-modal"
            opened={open}
            onClose={() => setOpen(!open)}
            centered={true}
            withCloseButton={false}
            size={size}
        >
            <div className="stepper-modal-content">
                <FormHeader
                    title={title}
                    subtitle={subtitle}
                    withCloseIcon={true}
                    closeModal={() => setOpen(false)}
                />
                <div className="stepper-inner-content">
                    <StepperTabs<T>
                        steps={steps}
                        currentTab={currentTab}
                        setTab={setTab}
                        goTo={goTo}
                    />
                    {children}
                </div>
            </div>
        </Modal>
    );
}
